import React, { useState } from 'react';
import T from 'prop-types';

import Button from '../Button';

import { downloadBlobWorkaround } from '../../../utils/download-blob';

export const AsyncScreenshotButton = ({
  requestParams,
  defaultFilename = 'download.png',
  disabled,
  apiRequest,
}) => {
  const [screenshotInProgress, setScreenshotInProgress] = useState(false);

  const makeScreenshoot = () => {
    setScreenshotInProgress(true);

    apiRequest(requestParams)
      .then((response) => {
        const contentDisposition = response.headers['content-disposition'];
        let filename = defaultFilename;

        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="(.+)"/);

          if (filenameMatch.length > 1) {
            [, filename] = filenameMatch;
          }
        }
        downloadBlobWorkaround(response.data, filename);
        setScreenshotInProgress(false);
      });
  };

  return (
    <Button
      variant="secondary"
      shape="square"
      disabled={disabled}
      loading={screenshotInProgress}
      onClick={makeScreenshoot}
    >
      <i className="hicon-snapshot" />
    </Button>
  );
};

AsyncScreenshotButton.propTypes = {
  requestParams: T.object,
  defaultFilename: T.string,
  disabled: T.bool,
  apiRequest: T.func.isRequired,
};
